import { TechRadarPage } from '@backstage-community/plugin-tech-radar';
import { createApp } from '@backstage/app-defaults';
import { AppRouter, FlatRoutes } from '@backstage/core-app-api';
import { AlertDisplay, OAuthRequestDialog, SignInPage } from '@backstage/core-components';
import { gitlabAuthApiRef } from '@backstage/core-plugin-api';
import { ApiExplorerPage, apiDocsPlugin } from '@backstage/plugin-api-docs';
import {
  CatalogEntityPage,
  CatalogIndexPage,
  catalogPlugin,
} from '@backstage/plugin-catalog';
import { catalogEntityCreatePermission } from '@backstage/plugin-catalog-common/alpha';
import { CatalogGraphPage } from '@backstage/plugin-catalog-graph';
import {
  CatalogImportPage,
  catalogImportPlugin,
} from '@backstage/plugin-catalog-import';
import { HomepageCompositionRoot } from '@backstage/plugin-home';
import { NotificationsPage } from '@backstage/plugin-notifications';
import { orgPlugin } from '@backstage/plugin-org';
import { RequirePermission } from '@backstage/plugin-permission-react';
import { ScaffolderPage, scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { SearchPage } from '@backstage/plugin-search';
import {
  TechDocsIndexPage,
  TechDocsReaderPage,
  techdocsPlugin,
} from '@backstage/plugin-techdocs';
import { ProviderSettingsItem, UserSettingsPage } from '@backstage/plugin-user-settings';
import { RbacPage } from '@janus-idp/backstage-plugin-rbac';
import { Star } from '@material-ui/icons';
import React from 'react';
import { Route } from 'react-router-dom';
import { apis } from './apis';
import { Root } from './components/Root';
import { entityPage } from './components/catalog/EntityPage';
import { HomePage } from './components/home/HomePage';
import { searchPage } from './components/search/SearchPage';
export { grafanaPlugin } from '@k-phoen/backstage-plugin-grafana';

const app = createApp({
  apis,
  bindRoutes({ bind }) {
    bind(catalogPlugin.externalRoutes, {
      createComponent: scaffolderPlugin.routes.root,
      viewTechDoc: techdocsPlugin.routes.docRoot,
    });
    bind(apiDocsPlugin.externalRoutes, {
      registerApi: catalogImportPlugin.routes.importPage,
    });
    bind(scaffolderPlugin.externalRoutes, {
      registerComponent: catalogImportPlugin.routes.importPage,
    });
    bind(orgPlugin.externalRoutes, {
      catalogIndex: catalogPlugin.routes.catalogIndex,
    });
  },
  components: {
    SignInPage: props => (
      <SignInPage
        {...props}
        auto={true}
        align='center'
        providers={[
          // 'guest',
          {
            id: 'gitlab',
            title: 'Gitlab Login',
            message: 'Sign in using Oneplatform SSO',
            apiRef: gitlabAuthApiRef,
          },
          // {
          //   id: 'auth0',
          //   title: 'Oneplatform Login',
          //   message: 'Sign in using Oneplatform SSO',
          //   apiRef: auth0AuthApiRef,
          // }
        ]}
      />
    ),
  },
});

const routes = (
  <FlatRoutes>
    <Route path="/" element={<HomepageCompositionRoot />}>
      <HomePage />
    </Route>
    <Route path="/catalog" element={<CatalogIndexPage />} />
    <Route
      path="/catalog/:namespace/:kind/:name"
      element={<CatalogEntityPage />}
    >
      {entityPage}
    </Route>
    <Route path="/docs" element={<TechDocsIndexPage />} />
    <Route
      path="/docs/:namespace/:kind/:name/*"
      element={<TechDocsReaderPage />}
    >
    </Route>
    <Route path="/create" element={<ScaffolderPage
      groups={[
        {
          title: "Infrastructure",
          filter: entity =>
            entity?.metadata?.tags?.includes('infrastructure') ?? false,
        },
      ]}
    />}
    />
    <Route path="/api-docs" element={<ApiExplorerPage />} />
    <Route
      path="/tech-radar"
      element={<TechRadarPage width={1500} height={800} />}
    />
    <Route
      path="/catalog-import"
      element={
        <RequirePermission permission={catalogEntityCreatePermission}>
          <CatalogImportPage />
        </RequirePermission>
      }
    />
    <Route path="/search" element={<SearchPage />}>
      {searchPage}
    </Route>
    <Route path="/settings" element={<UserSettingsPage providerSettings={
      <ProviderSettingsItem
        title='Gitlab'
        description='Provide Sign-In via Gitlab'
        icon={Star}
        apiRef={gitlabAuthApiRef} />
    } />} />
    <Route path="/catalog-graph" element={<CatalogGraphPage />} />
    <Route path="/scaffolder" element={<ScaffolderPage />} />
    <Route path="/notifications" element={<NotificationsPage />} />
    <Route path='/admin' element={<RbacPage />} />
    <Route path="/rbac" element={<RbacPage />} />;
  </FlatRoutes>
);

export default app.createRoot(
  <>
    <AlertDisplay />
    <OAuthRequestDialog />
    <AppRouter>
      <Root>{routes}</Root>
    </AppRouter>
  </>,
);
